<div class="page" title="Page 1">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h1>Condiciones Generales de Nuevo Mundo Chile</h1>
        <p>Es obligatorio que lea y entienda estas condiciones generales y la información y condiciones específicas
          del producto y/o servicio que quiere contratar o adquirir antes de proceder a su compra.</p>
        <p>Nos reservamos el derecho a realizar cambios en cualquier momento en nuestro sitio web, así como en estas
          condiciones generales. Los cambios de elementos esenciales no afectarán a los contratos ya estipulados a no
          ser que haya expresamente aceptado las condiciones modificadas.</p>
        <h3>CONDICIONES DE COMPRA</h3>
        <h4>A) DECLARACIONES GENERALES</h4>
        <ol>
          <li>
            <p>Declaro ser mayor de edad y tener la capacidad legal para adquirir los servicios ofrecidos a través de
              este sitio web.</p>
          </li>
          <li>
            <p>Declaro que toda la información registrada es exacta, clara y detallada.</p>
          </li>
          <li>
            <p>Como Cliente autorizo a Rappi Travel, o al proveedor de los servicios adquiridos, a debitar de mi
              Tarjeta de Crédito los valores en la forma seleccionada en el flujo de Pagos habilitado en el proceso
              de compra</p>
          </li>
          <li>
            <p>Al aceptar este contrato, como Cliente me comprometo a enviarlo con todos los datos completos, junto
              con una copia de mi documento de identidad, en caso de que sea solicitado por Rappi Travel</p>
          </li>
          <li>
            <p>Como Cliente declaro conocer y aceptar las reglas de Cancelación y Reembolso, y los recargos que ellos
              puedan generar.</p>
          </li>
          <li>
            <p>Declaro haber sido informado que mi solicitud de compra será atendida dentro de las 72 horas corridas
              de adquirido el servicio. Luego de procesada la compra, el ticket y/o voucher será enviado dentro de
              las 24 horas hábiles siguientes.</p>
          </li>
          <li>
            <p>Con la efectiva cobranza a través del medio de pago seleccionado por mí en el flujo de compra
              anterior, Nuevo Mundo Chile se compromete a gestionar por mi cuenta y orden los servicios seleccionados
              con anterioridad.</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 2">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <ol start="8">
          <li>
            <p>Declaro que he sido, debida y previamente, informado respecto de los servicios contratados, así como
              de las condiciones, regulaciones y restricciones que conllevan, las mismas que me han sido detalladas y
              explicadas debidamente, y que acepto plenamente.</p>
          </li>
          <li>
            <p>Declaro haber sido informado y acepto que es mi responsabilidad como Cliente contar con la
              documentación en regla de acuerdo con el destino y/o nacionalidad, esto es tener pasaporte vigente
              (mínimo 6 meses) y visas vigentes de los países por los que voy a viajar, vacunas, permiso de menores
              en caso sea necesario y la documentación respectiva para realizar el viaje. Cualquier requerimiento del
              país de destino en relación a esquema de vacunación, exámenes o procedimientos médicos exigidos,
              permisos especiales o restricciones específicas son responsabilidad exclusiva del Cliente, tanto en su
              conocimiento como en su cumplimiento.</p>
          </li>
          <li>
            <p>Declaro hacerme responsable de todas las consecuenciasderivadas de cualquier utilización de esta
              página web, incluido el mal uso de las contraseñas que en su caso un tercero no autorizado o yo mismo,
              pueda llevar a cabo, evitando el acceso a cualquier persona no autorizada a datos personales, que solo
              yo deba conocer, como un posible nombre de usuario o los datos de mi tarjeta de crédito.</p>
          </li>
          <li>
            <p>Como Cliente me responsabilizo de la revisión del correo electrónico que he señalado para efectos de
              creación de Usuario, por lo que declaro tener conocimiento de las comunicaciones que se me efectúen
              por esta vía.</p>
          </li>
          <li>
            <p>Declaro que en caso de no aceptar las presentes Condiciones Generales de Compra, no podré acceder ni
              utilizar los servicios y/o contenidos ofertados en esta página.</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 3">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h4>B) RESPONSABILIDAD</h4>
        <ol>
          <li>
            <p>Nuevo Mundo Chile declara expresamente que actúa en la condición exclusiva de intermediaria en la
              reserva o contratación de los distintos servicios turísticos y su responsabilidad será determinada
              únicamente en tal condición conforme a las disposiciones legales sobre la materia.</p>
          </li>
          <li>
            <p>Nuevo Mundo Chile no se responsabiliza por los hechos que se produzcan por caso fortuito o fuerza
              mayor, fenómenos climáticos o hechos de la naturaleza que acontezcan antes o durante el desarrollo de
              los servicios que impidan, demoren o de cualquier modo obstaculicen la ejecución total o parcial de las
              prestaciones contratadas. No obstante, lo declarado en el párrafo que antecede, Nuevo Mundo Chile
              brindará soporte al cliente, en su condición de intermediaria, para la mejor solución del problema y
              de corresponder, solicitar los reembolsos respectivos, de acuerdo a las políticas de los operadores. Se
              aclara que esta obligación de soporte es una de medios y no de resultados.</p>
          </li>
          <li>
            <p>Nuevo Mundo Chile no se responsabiliza por las alteraciones de horarios, postergaciones y/o
              cancelaciones, las comodidades, equipos utilizados o cualquier otra modificación realizada por las
              empresas transportadoras, ni por cualquier otro hecho de tercero, no imputable a Nuevo Mundo Chile, que
              afecten la prestación del servicio. No obstante, lo declarado en el párrafo que antecede, Nuevo Mundo
              Chile brindará soporte al cliente, en su condición de intermediario, para la mejor solución del
              problema y de corresponder, solicitar los reembolsos respectivos, de acuerdo a las políticas de los
              operadores. Se aclara que esta obligación de soporte es una de medios y no de resultados.</p>
          </li>
          <li>
            <p>En ningún caso Nuevo Mundo Chile responderá frente al Cliente por daños indirectos o lucro cesante
              alegado por él, referidos a hechos en los cuales los funcionarios, empleados o representantes de Nuevo
              Mundo Chile no hayan tenido participación en ellos. Se aclara que solo se responderá de estos casos en
              el escenario de que el cliente acredite debidamente que les son imputables.</p>
          </li>
          <li>
            <p>Nuevo Mundo Chile se reserva el derecho de procesar, o no, cualquier operación de compra, en donde se
              evidencie o haya sospecha de transacción dudosa o fraude, pudiendo solicitar al cliente documentación
              adicional y su presencia física en sus oficinas para la firma del voucher. Asimismo, Nuevo Mundo Chile
              podrá requerir al Cliente el cambio de la modalidad de pago por él seleccionada, de ser necesario para
              concretar su operación de compra.</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 4">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h4>C) SOLICITUDES Y PAGOS</h4>
        <ol>
          <li>
            <p>El precio estimado en el momento de la solicitud de servicios y hasta que no se haya efectuado la
              emisión de los pasajes u órdenes de servicio y su facturación y pago, queda sujeto a disponibilidad y a
              modificaciones sin previo aviso. Cuando se produzca una alteración en los mismos y/o modificaciones en
              sus
              costos y/o en el tipo de cambio aplicado y/o por la aplicación de los impuestos que correspondan de
              acuerdo a la normativa vigente, Nuevo Mundo Chile no será responsable de los mayores costos resultantes,
              los que deberán ser comunicados al cliente a su correo electrónico. En caso se realice una cotización
              de
              cambio de manera excepcional , después de calculado el precio final éste será informado al cliente
              previamente para su conformidad total de modo que después pueda efectuar el pago en señal de
              conformidad.
            </p>
            <p>Cada Pasaje Aéreo se encuentra regulado por una serie de condiciones y restricciones determinadas por
              cada
              Compañía Aérea para cada tarifa en particular. De acuerdo al monto de la tarifa, se imponen ciertas
              limitaciones sobre la utilización del Pasaje Aéreo, por ejemplo: no reembolsable, no transferible,
              restricciones sobre cambios de ruta, imposición de estadías mínimas y máximas, restricciones a la
              devolución del importe abonado, etc. Las tarifas más económicas son las que mayores restricciones
              poseen.
              Tenga presente que Nuevo Mundo Chile no se encuentra autorizada a variar ni modificar en ningún caso las
              regulaciones de los Pasajes Aéreos.</p>
          </li>
          <li>
            <p>Los boletos aéreos están sujetos al Impuesto al Valor Agregado (IVA) cuando se expidan en el país o
              de aquellos documentos que aumenten o disminuyan el valor de venta de los pasajes, siempre que el
              servicio se inicie o termine en el país, así como cuando se adquieran en el extranjero para ser
              utilizados desde el país.</p>
          </li>
          <li>
            <p>Todos los importes pagados antes de la confirmación de los servicios son recibidos por concepto de
              reserva.</p>
          </li>
          <li>
            <p>Los precios definitivos quedarán fijados a partir del momento de la confirmación definitiva de los
              servicios que se produce con la emisión de los pasajes u órdenes de servicios, vouchers y su
              facturación.</p>
          </li>
          <li>
            <p>De no efectuarse el pago del precio, Nuevo Mundo Chile queda facultada a cancelar los servicios con
              previo aviso al Cliente, no teniendo el Cliente derecho a reintegro alguno.</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 5">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h4>D) SERVICIOS NO INCLUIDOS</h4>
        <p>Sólo debe considerarse incluido en los precios aquello que está expresa y literalmente detallado en la
          documentación de viaje, de lo que se desprende que no está incluido en los precios: equipaje adicional al
          incluído en el pasaje comprado por el cliente, visados, certificados de vacunación, tasas de embarque o de
          aeropuertos, extras en hoteles (cafés, licores, aguas minerales, lavado y planchado, propinas,
          comunicaciones, resort fee y cargos adicionales en hoteles, llamadas telefónicas sin costo, periódicos,
          cajas de seguridad, deportes o
          excursiones no incluidos, etc.), tasas sobre servicios, impuestos, gastos e intereses de operaciones
          financieras, excursiones y visitas opcionales, alimentación extra en ruta, comidas y/o gastos adicionales,
          o perjuicios producidos por cancelaciones, demoras en las salidas o llegadas de los medios de transporte, o
          por razones imprevistas ajenas a Nuevo Mundo Chile, entre otros.
        </p>
        <h4>E) DOCUMENTACIÓN</h4>
        <p>Es responsabilidad del Cliente informarse sobre los requisitos que exigen las autoridades migratorias,
          aduaneras y sanitarias de los destinos, siendo responsabilidad exclusiva del Cliente contar con la
          documentación personal que exijan las autoridades mencionadas. Nuevo Mundo Chile no será responsable por
          inconvenientes que sufriera el Cliente que carezca de documentos en las condiciones necesarias ya sea al
          salir o al entrar en este u otro país. Debe tenerse en cuenta que la obtención de las visas en los países
          a visitar por el Cliente corren por exclusiva responsabilidad de éste, como así también la presentación
          de la documentación necesaria para el ingreso a los países de destino y documentos de sanidad requeridos
          (vacunas o exámenes médicos).</p>
        <h4>F) HOTELES</h4>
        <ol>
          <li>
            <p>Informamos que cada hotel tiene sus propias regulaciones en el servicio y condiciones tarifarias, así
              como la categorización de tipos de habitación. El horario de ingreso puede variar según la temporada
              y ocupación del mismo. Todas las reservaciones se generan en habitación estándar a excepción de
              casos que se haya solicitado otro tipo de habitación.</p>
          </li>
          <li>
            <p>El Cliente deberá tener al menos 18 años para poder realizar el check in, a menos que se encuentre
              acompañado de sus padres o un representante legal. En el extranjero deberá contar con una tarjeta de
              crédito como garantía si así se lo requieren al momento del check in.</p>
          </li>
          <li>
            <p>En algunos hoteles los cargos adicionales no están incluidos y deberán pagarse directamente en
              destino. Los impuestos y cargos adicionales de pago obligatorio en el hotel serán informados en la
              información importante, antes de pagar la reserva, es responsabilidad del usuario consultar esta
              información.</p>
            <p>Las reservas garantizan la ocupación máxima de personas en la habitación; la distribución de camas
              depende del lugar del hospedaje. Se recomienda consultar en caso de las habitaciones TRIPLE Y CUÁDRUPLE.
              Así mismo si tienen alguna solicitud especial al momento de generar su reserva. Las
              solicitudes especiales se confirman solo en el lugar del hospedaje no se pueden confirmar antes de la
              llegada.
            </p>
          </li>
          <li>
            <p>Se recomienda a los clientes llevar impreso su voucher de reserva. En caso Ud. no se presente en el
              Hotel en la fecha y horario correspondiente, el Hotel puede cancelar su reserva y considerarla como NO
              SHOW lo cual afectaría cualquier solicitud de reembolso total o parcial.
            </p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 6">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h4>H) AUTOS</h4>
        <ol>
          <li>
            <p>Informamos que cada arrendadora de autos tiene sus propias regulaciones de servicio, así como sus
              condiciones tarifarias y contractuales aplicables al alquiler de vehículos.</p>
          </li>
          <li>
            <p>En caso de requerir alguna cancelación debe informar a Rappi Travel como máximo 48 horas corridas
              antes de la hora y fecha de inicio de alquiler de reserva.</p>
          </li>
          <li>
            <p>La reserva de auto se realiza para una categoría específica, se garantiza el tamaño y capacidad, la
              información de modelo y marca es referencial. El arriendo del auto se realiza por un periodo o bloque
              determinado (día, semana, horas). Estos incluyen kilometraje y/o millaje ilimitado y los requisitos y
              seguros mínimos para retirar el auto y circular en la localidad indicada. La tarifa de arrendamiento no
              incluye el pago de multas, impuestos, infracciones, arrastre de grúas, gasolina, cargos por dejar el
              auto en otra ciudad, ni cualquier servicio adicional. En caso se extienda el periodo de alquiler o se
              retire o entregue el auto fuera de las horas estipuladas o en otra localidad pueden existir cargos
              adicionales. Los impuestos y tasas en algunos casos están incluidos de acuerdo a la tarifa solicitada.
            </p>
          </li>
          <li>
            <p>El conductor deberá ser mayor de 18 años. Dependiendo de su rango etario se le podrá solicitar
              documentación extra y/o solicitar se paguen cargos adicionales.</p>
          </li>
          <li>
            <p>El conductor debe llevar consigo el voucher de reserva emitido por Nuevo Mundo Chile, a través de la
              plataforma de RappiTravel,permiso de conducir vigente y válido en el lugar de destino, tarjeta de
              crédito internacional propia con saldo disponible en caso de garantía y pasaporte vigente.</p>
          </li>
          <li>
            <p>En caso que desee contratar tarifas con seguros y servicios adicionales (seguros con pólizas contra
              terceros, cargos de gasolina, cargo por conductor adicional), puede revisar la información de reserva y/o
              solicitarlo al asesor de venta.</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 7">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h4>I) CANCELACIONES</h4>
        <p>En caso de desistimiento por parte del Cliente de servicios contratados en firme por Nuevo Mundo Chile a
          terceros, las cancelaciones estarán sujetas a las condiciones contractuales bajo las cuales estos últimos
          presten sus servicios, las mismas que han sido informadas al cliente en el Flujo de compra. En todos los
          casos de reintegro, la agencia podrá retener del precio, los gastos incurridos más la comisión de los
          servicios contratados con terceros.Nuevo Mundo Chile no es responsable por los servicios que no fueran
          tomados por el Cliente en tiempo y forma convenidos, ni por las consecuencias que de ello emanen, como la
          cancelación del servicio por parte del prestador, ni por el reintegro, reembolso o devolución del importe
          abonado por dicho servicio.Respecto a la devolución de boletos aéreos, el Cliente acepta las condiciones
          impuestas por las regulaciones de las compañías aéreas en relación a este trámite.</p>
        <h4>J) CANCELACI&Oacute;N GRATUITA A&Eacute;REOS</h4>
        <p>Para poder hacer uso de esta cancelaci&oacute;n, se deben cumplir las siguientes condiciones:</p>  
        <ol type="I" start="1"> 
          <li>La fecha de compra y la fecha de cancelaci&oacute;n deben ser la misma, de acuerdo a la zona horaria de Chile.</li>
          <li>La hora m&aacute;xima de cancelaci&oacute;n es hasta las 23:45 horas del d&iacute;a de la emisi&oacute;n del ticket a&eacute;reo.</li>
          <li>La reserva no debe tener un Check-In activo al momento de la cancelaci&oacute;n.</li>
          <li>La devoluci&oacute;n se realizar&aacute; a trav&eacute;s del m&eacute;todo de pago original.</li>
        </ol>
        <h4>K) CAMBIO DE FECHA</h4>
        <p>El cambio de fecha de los boletos aéreos según la política de la aerolínea y condiciones de compra.
          El cambio de fecha respecto de otro servicio turístico queda sujeto a las modalidades, condiciones y
          disponibilidad de los distintos prestadores de los servicios, en caso se realice una cotización de cambio
          de manera excepcional, este aplicará con un gasto que será informado, así como la diferencia tarifaria si
          correspondiese. Una vez habiéndose calculado el precio final, éste será informado al cliente previamente
          para su conformidad , pudiendo éste, con posterioridad, efectuar el pago en señal de aceptación.
          Tratándose de pasajes domésticos se estará las políticas y directivas de cada Línea Aérea.</p>
        <p>Sin perjuicio de lo señalado con anterioridad, se debe tener en consideración que cualquier
          modificación en el servicio puede traer aparejada una multa o costos adicionales no previstos en la reserva
          inicial.</p>
        <h4>L) PROCEDIMIENTO DE CONSULTAS O RECLAMOS</h4>
        <p>En el caso de que Usted necesite efectuar un reclamo y/o consulta, solicitar modificaciones y/o
          cancelaciones, -siempre que su tarifa lo permita-, solicitar el reenvío de vouchers o tickets, puede
          contactarse con su equipo de
          soporte y atención al cliente. Recuerde que Nuevo Mundo Chile es una plataforma de intermediación y, como
          tal, su principal vía de contacto es en línea. Independientemente de ello, para cualquier urgencia siempre
          cuenta con líneas telefónicas que constan en los correos y/o vouchers enviados con cada Servicio
          Turístico.</p>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 8">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <ol>
          <li>
            <p>En el caso de querer realizar un reclamo, sugerencia o consulta, esta deberá ser canalizada por el
              cliente enviando un correo electrónico a la siguiente dirección de correo:
              servicioalclientech&#64;rappitravel.com. Se recomienda realizar una descripción detallada de los hechos
              adjuntando de inmediato la copia de los antecedentes de respaldo, explicando lo ocurrido y formulando en
              términos claros, simples y la solución que desea. De esta manera, podremos revisar su caso en forma
              más rápida y eficiente. Promotora de Nuevo Mundo Chile analizará el reclamo, y dará respuesta al
              mismo correo electrónico informado por Usted lo antes posible. Si de la revisión de los antecedentes
              resultara procedente acoger en todo o en parte el reclamo, Nuevo Mundo Chile se lo hará saber y le
              solicitará la conformidad del acuerdo por mail.</p>
          </li>
          <li>
            <p>Los cambios o cancelaciones de reservas efectuadas por nuestro intermedio, si bien son regidos por los
              Proveedores de los Servicios Turísticos, deben ser gestionados a través de Nuevo Mundo Chile. En
              cualquiera de los casos anteriores, la línea aérea y/o el proveedor lo derivarán a nuestra empresa.
            </p>
          </li>
          <li>
            <p>En los casos de servicios de vuelos regulares, las condiciones son impuestas por las transportadoras
              con quien el Cliente deberá entenderse directamente y reclamar en su caso por cualquier inconveniente o
              perjuicio sufrido como consecuencia del viaje. Nuevo Mundo Chile no tiene control sobre estas
              condiciones y ofrecerá todo apoyo a su alcance para llevarlas a cabo. Se aclara que esta obligación es
              de medios y no de resultados.</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 9">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h4>M) PRESENTACIÓN EN EL AEROPUERTO</h4>
        <p>Usted deberá presentarse en el Aeropuerto de partida, el día previsto y a la hora indicada, con la
          Documentación de Viaje. Para vuelos domésticos aconsejamos presentarse en el aeropuerto con 3 horas de
          anticipación y, para vuelos internacionales, la anticipación deberá ser de al menos 4 horas. Si Usted no
          se presenta a embarcar o llega con atraso a embarcar en la fecha y horarios indicados, se configura lo que
          en el mercado turísticos se conoce como No Show y la Compañía</p>
        <p>Aérea puede cancelar cualquier reserva para la continuación del viaje o el retorno y Usted no tendrá
          derecho a exigir la devolución total o parcial del importe abonado.</p>
        <h4>N) SEGUROS</h4>
        <p>Le aconsejamos que viaje siempre convenientemente asegurado. En ciertos casos, le ofrecemos la
          posibilidad de añadir un seguro a su viaje en ciertos destinos. Adicionalmente nuestros agentes le
          proporcionarán toda la información que pueda necesitar para decidir si quiere contratar el seguro
          propuesto. Tenga en cuenta que los seguros no permiten cancelaciones, por tanto no son reembolsables, a
          menos que su visado haya sido denegado, en cuyo caso debe contactarse con nosotros para su devolución,
          previa aplicación de la penalidad correspondiente de acuerdo a las políticas del prestador del servicio.
        </p>
        <p>
          Los seguros señalados en el presente apartado no se encuentran incorporados en el valor de los tickets.
        </p>
        <h4>Ñ) EQUIPAJE</h4>
        <p>Todas las compañías aéreas tienen diferentes políticas de franquicias de equipajes. Infórmese antes
          de viajar. Nuevo Mundo Chile no se responsabiliza por el deterioro y/o extravío y/o hurto y/o robo y/o
          pérdida del equipaje y demás efectos personales de los pasajeros. En caso de pérdida o deterioro de
          equipaje, Usted debe dirigirse a las oficinas de atención al cliente de la compañía aérea y realizar el
          correspondiente reclamo. Se recomienda al Cliente contratar un seguro de viaje para cubrir parte de los
          riesgos mencionados.</p>
        <h4>O) ACEPTACIÓN DEL CLIENTE</h4>
        <p>Las presentes condiciones generales, junto con la restante documentación que se entrega al Cliente,
          conforman el Contrato de Viaje. Estas condiciones son entregadas por Nuevo Mundo Chile al Cliente al momento
          de realizar la reserva de los servicios. El Cliente declara conocer y aceptar las presentes condiciones
          generales de contratación y dicha aceptación queda ratificada por medio de uno cualquiera de los
          siguientes actos:</p>
        <ol>
          <li>
            <p>El pago de la reserva y/o de los servicios contratados antes del inicio del viaje, por cualquier forma
              o modalidad.</p>
          </li>
          <li>
            <p>La aceptación de la factura de los servicios contratados.</p>
          </li>
          <li>
            <p>Mediante el uso de una parte cualquiera de los servicios contratados.</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
<div class="page" title="Page 10">
  <div class="section">
    <div class="layoutArea">
      <div class="column">
        <h4>P) AUTORIZACIÓN DEL CLIENTE PARA EL MANEJO DE DATOS PERSONALES</h4>
        <p>El Cliente, titular de los datos personales, otorga su consentimiento de manera indefinida, libre,
          previo, expreso, inequívoco e informado para que Nuevo Mundo Chile y en tanto este consentimiento no sea
          revocado, pueda realizar el tratamiento de sus datos personales con las siguientes finalidades: i) decidir
          el otorgamiento de servicios que solicite, (ii) efectuar la cobranza de los servicios solicitados, (iii)
          ofrecerle otros servicios de Nuevo Mundo Chile y/o de sus vinculadas; (iv) enviar ofertas comerciales,
          promociones, publicidad e información general de los productos y/o servicios de Nuevo Mundo Chile y/o de
          sus vinculadas, (v) usar y/o transferir esta información (dentro o fuera del país) a terceros y/o a
          cualquier vinculada de Nuevo Mundo Chile; (vi) formalizaciones contractuales; (vii) remisión de
          correspondencia; (viii) enviar a los proveedores del servicio de conexión tecnológica para recibir los
          pagos aceptando medios de pago autorizados por Nuevo Mundo Chile.</p>
        <p>Nuevo Mundo Chile tratará sus datos personales con la más estricta confidencialidad, adoptará las
          medidas de seguridad Ley 19.628, Ley sobre Protección de la vida privada , su reglamento y modificaciones;
          y usará sus datos personales autorizados para las finalidades expresamente establecidas. El Cliente declara
          haber sido informado que podrá revocar en cualquier momento su consentimiento, comunicando su decisión por
          escrito, lo cual no afectará el uso de sus datos ni el contenido de las bases de datos de Nuevo Mundo Chile
          para la ejecución y/o desarrollo de la relación contractual que mantiene con Nuevo Mundo Chile Asimismo,
          el Cliente podrá ejercitar los derechos de acceso, rectificación, cancelación u oposición que, en su
          caso, le correspondan conforme a la ley precitada, mediante una solicitud por escrito presentada a Nuevo
          Mundo Chile : Av. Apoquindo 5950, piso 5, Las Condes y/o correo electrónico &ldquo;
          servicioalclientech&#64;rappitravel.com&ldquo;</p>
      </div>
    </div>
  </div>
</div>